import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { connect } from "react-redux";
import { DynamicInvoiceDialog } from "./dynamic-invoice-dialog";
import { actions } from "./dynamic-invoice-dialog-controller-store";
const mapStateToProps = (state) => state.dynamicInvoices.dynamicInvoicesPages.dynamicInvoicesPage.dynamicInvoiceDialogController;
const DynamicInvoiceDialogControllerBase = (props) => {
    useEffect(() => {
        props.initialize(props.preparedInvoice);
        return () => {
            props.clear();
        };
    }, [props.initialize, props.clear, props.preparedInvoice]);
    if (props.loading.loadingState !== "has-finished")
        return null;
    return _jsx(DynamicInvoiceDialog, { preparedInvoice: props.loading.data.preparedInvoice });
};
export const DynamicInvoiceDialogController = connect(mapStateToProps, actions)(DynamicInvoiceDialogControllerBase);
